'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _isSameElement = require('../../helpers/isSameElement');var _isSameElement2 = _interopRequireDefault(_isSameElement);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _getIconStatus = require('../../utils/getIconStatus');

var _ActionsTooltip = require('./ActionsTooltip.scss');var styles = _interopRequireWildcard(_ActionsTooltip);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Style
var ActionsTooltip = function (_Component) {_inherits(ActionsTooltip, _Component);function ActionsTooltip() {var _temp, _this, _ret;_classCallCheck(this, ActionsTooltip);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.







    bodyClickHandler = function (evt) {
      if (!_this.props.isTooltipShown) {
        return;
      }
      if (!(0, _isSameElement2.default)(_this.node, evt.target)) {
        evt.stopPropagation();
        _this.props.hideTooltip();
      }
    }, _this.









    toggleActivity = function () {return !_this.props.property.is_suspended && _this.props.updatePropertyActivity({
        ids: [_this.props.property.id],
        active: !_this.props.property.is_active });}, _this.


    renderActivity = function () {return _this.props.property.is_active ?
      _react2.default.createElement('div', null,
        _react2.default.createElement('span', { className: 'icon icon-inactive' },
          _react2.default.createElement('span', { className: 'path1' }),
          _react2.default.createElement('span', { className: 'path2' })),

        _this.props.translate('deactivate')) :

      _react2.default.createElement('div', { className: styles.activeIconContainer },
        _react2.default.createElement('span', { className: 'icon icon-active' },
          _react2.default.createElement('span', { className: 'path1' }),
          _react2.default.createElement('span', { className: 'path2' })),

        _this.props.translate('makeActive'));}, _temp), _possibleConstructorReturn(_this, _ret);}ActionsTooltip.prototype.componentDidMount = function componentDidMount() {document.body.addEventListener('click', this.bodyClickHandler);};ActionsTooltip.prototype.componentWillUnmount = function componentWillUnmount() {document.body.removeEventListener('click', this.bodyClickHandler);}; // handleEdit = (event) => {
  //   event.stopPropagation();
  //   this.props.editProperty(this.props.property.id);
  //   setTimeout(() => {
  //     browserHistory.push(appendLocale(this.props.locale, `/property/edit?id=${this.props.property.id}`));
  //   });
  // };
  ActionsTooltip.prototype.render = function render() {var _this2 = this,_cx,_cx2,_cx3;var _props =




    this.props,isPublishPermissionsForeign = _props.isPublishPermissionsForeign,_props$property = _props.property,isPromoted = _props$property.is_promoted,isSuspended = _props$property.is_suspended,isActive = _props$property.is_active,address = _props$property.address;

    var canMoveToTop = !isSuspended && this.props.property.is_active && this.props.property.move_to_top;
    var isAutoJumpEnabled = (0, _get2.default)(this.props, 'property.is_autojump_enabled');
    var autoJumpStatus = (0, _getIconStatus.getIconStatus)(isAutoJumpEnabled, this.props.jumpPromotion);
    var promotionStatus = (0, _getIconStatus.getIconStatus)(isPromoted, this.props.promotion);
    var isForeignProperty = (0, _checkIsForeignAddress2.default)(address);

    return (
      _react2.default.createElement('div', {
          onClick: this.props.hideTooltip,
          className: styles.tooltipWrapper,
          ref: function ref(node) {_this2.node = node;} },

        _react2.default.createElement('div', { className: styles.shareRow, onClick: this.props.openDetailsPopup },
          _react2.default.createElement('i', { className: 'icon icon-preview' },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),

          this.props.translate('openDetails')),







        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.shareRow, (_cx = {}, _cx[styles.disabled] = !isActive, _cx)), onClick: this.props.toggleHighlight },
          _react2.default.createElement('i', { className: 'icon icon-promoted' + (0, _getIconStatus.addEnding)(promotionStatus) },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),

          isPromoted ? this.props.translate('colorUnHighlight') : this.props.translate('colorHighlight')),


        _react2.default.createElement('div', {
            className: (0, _classnames2.default)(styles.shareRow, (_cx2 = {}, _cx2[styles.disabled] = !isActive, _cx2)),
            onClick: this.props.toggleAutoJumpActivity },

          _react2.default.createElement('i', { className: (0, _classnames2.default)('icon', 'icon-auto-jump' + (0, _getIconStatus.addEnding)(autoJumpStatus)) },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),

          isAutoJumpEnabled ? this.props.translate('disableAutoJumpToTop') : this.props.translate('autoJumpToTop')),


        !isAutoJumpEnabled &&
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)(styles.shareRow, (_cx3 = {}, _cx3[styles.disabled] = !canMoveToTop, _cx3)),
            onClick: this.props.toggleMoveToTop },

          _react2.default.createElement('i', { className: 'icon icon-jump-to-top' },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),

          this.props.translate('jumpToTop')),


        !isPublishPermissionsForeign && !isActive && isForeignProperty ? '' :

        _react2.default.createElement('div', {
            className: '' + styles.shareRow + (isSuspended ? ' ' + styles.notAllowed : ''),
            onClick: this.toggleActivity },

          this.renderActivity())));





  };return ActionsTooltip;}(_react.Component);exports.default = ActionsTooltip;


ActionsTooltip.propTypes = {
  hideTooltip: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  isTooltipShown: _propTypes2.default.bool,
  editProperty: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  property: _propTypes2.default.object,
  openDetailsPopup: _propTypes2.default.func,
  updatePropertyActivity: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  toggleHighlight: _propTypes2.default.func.isRequired,
  toggleAutoJumpActivity: _propTypes2.default.func.isRequired,
  toggleMoveToTop: _propTypes2.default.func.isRequired,
  jumpPromotion: _propTypes2.default.object,
  promotion: _propTypes2.default.object,
  isPublishPermissionsForeign: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ActionsTooltip/ActionsTooltip.js
// module id = 2596
// module chunks = 0